<div class="no-print container mt-3 mb-1">
  <div class="d-flex justify-content-between align-items-center">
    <h3>
      <span class="font-bold"
        >{{ activeSeasonId }} {{ 'selectVaccines.season' | cxTranslate }}</span
      >
    </h3>
    <div class="d-flex gap-3">
      <span class="c-link" (click)="backToCategory()">
        <i class="fa fa-icon fa-chevron-left"></i>
        <span>{{ 'orderConfirmation.continueShopping' | cxTranslate }}</span>
      </span>
      <a
        class="c-link"
        [ngbPopover]="popClearCartContent"
        [popoverTitle]="popTitle"
        triggers="manual"
        #p1="ngbPopover"
        placement="top"
        (click)="toggle(p1)"
        container="body"
        popoverClass="popover-links">
        <i class="fas fa-trash-alt pointer"></i>
        <span> {{ 'orderConfirmation.clearCart' | cxTranslate }}</span>
      </a>
      <ng-template #popTitle
        ><span class="text-header text-center">
          {{ 'addToCartItems.clearTitle' | cxTranslate }}</span
        >
      </ng-template>
      <ng-template #popClearCartContent>
        <div class="d-flex gap-1">
          <button
            type="reset"
            class="popover-close c-button c-button--secondary popover-cancel-button"
            data-di-id="di-id-d01008be-fb6e135c"
            (click)="toggle(p1)">
            {{ 'addToCartItems.cancel' | cxTranslate }}
          </button>
          <button
            class="popover-close c-button c-button--primary popover-cancel-button"
            type="submit"
            data-di-id="di-id-3064f17d-e97cc628"
            (click)="deleteEntireCart(p1)">
            {{ 'orderConfirmation.clearCart' | cxTranslate }}
          </button>
        </div>
      </ng-template>
      <span class="c-link" (click)="onFluPrint()">
        <i class="fa fa-print"></i>
        {{ 'orderConfirmation.print' | cxTranslate }}
      </span>
    </div>
  </div>
</div>
<div *ngIf="deleteSuccess" class="global-alerts">
  <div class="alert delalert-info alert-dismissable getAccAlert">
    <button
      (click)="closeAlert()"
      class="close closeDelAlert"
      aria-hidden="true"
      data-dismiss="alert"
      type="button">
      ×
    </button>
    <span [innerHTML]="deleteSuccess" class="delete-Sucess-Prod-Name"></span>
    {{ 'selectVaccines.deleteSuccessMsg' | cxTranslate }}.
  </div>
</div>

<div
  *ngIf="blockCheckout && showDangerAlert && fluProductsList?.length > 0"
  class="global-alerts">
  <div class="alert alert-danger alert-dismissable getAccAlert">
    <button
      (click)="closeDangerAlert()"
      class="close closeAccAlert"
      aria-hidden="true"
      data-dismiss="alert"
      type="button"
      data-di-id="di-id-4f6d7b93-70563360">
      ×
    </button>
    {{ 'selectVaccines.orderBlockMsg' | cxTranslate }}
  </div>
</div>
<app-flu-header [selectedHeader]="header"></app-flu-header>

<section class="container influenzaCategory-Container">
  <section class="row">
    <!-- =====================estimation Section for IpAD(Potrait)======================= -->
    <section
      class="container est-Main-Container ipad-Container mobile-Container">
      <section class="row">
        <section class="col-md-12 col-lg-12 col-xl-12 text-center">
          <span class="col-8 c-widget-title c-heading c-heading-h3 text-center">
          </span>
          <span>{{
            cartNeedToBeUpdated ? '-' : estimatedSubtotal?.formattedValue
          }}</span>
        </section>
        <section class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 no-print">
          <div class="mt-5 px-3">
            <button
              class="c-button c-button--primary"
              (click)="navigateToCheckout()"
              *ngIf="!cartNeedToBeUpdated"
              [ngClass]="{ 'block-Click': disableButton }"
              [disabled]="
                fluProductsList.length == 0 || !minDosesThresholdRespected
              ">
              <i class="fa fa-spinner fa-spin" *ngIf="disableButton"></i>
              {{ 'selectVaccines.proceedToCheckout' | cxTranslate }}
            </button>
            <button
              class="c-button c-button--primary"
              *ngIf="cartNeedToBeUpdated"
              (click)="navigateToCheckout()"
              [ngClass]="{ 'block-Click': disableButton }"
              [disabled]="
                fluProductsList.length == 0 || !minDosesThresholdRespected
              ">
              <i class="fa fa-spinner fa-spin" *ngIf="disableButton"></i>
              {{ 'selectVaccines.updateOrder' | cxTranslate }}
            </button>
          </div>
        </section>
      </section>
    </section>
    <!-- =====================Left Section========================= -->
    <section class="col-8 mt-5 u-border-top-grey" *ngIf="!showEmptyCart">
      <!-- ===========================Shipping Address and Total Bill======================== -->
      <section
        class="row shipping-Bill-Main-Section u-border-bottom-grey"
        *ngIf="isPharmacyUser$ | async">
        <section class="col-sm-6 col-md-6 col-lg-6 loc-left">
          <h3 class="font-bold">
            {{ 'orderConfirmation.shiptoLoc' | cxTranslate }}
          </h3>
          <section class="ship-address">
            <section class="d-flex">
              <section class="location-icon">
                <span class="glyph-icon">
                  <i class="fas fa-map-marker-alt icon mr-3"></i>
                </span>
              </section>
              <section class="d-flex flex-column">
                <span class="selected-loc"
                  >{{ selectedData?.companyName }}
                  {{ '(' + selectedData?.unitID + ')' }}
                </span>
                <span>
                  {{ selectedData?.line1 ? selectedData?.line1 + ', ' : '' }}
                  {{ selectedData?.line2 ? selectedData?.line2 + ', ' : '' }}
                  {{ selectedData?.town ? selectedData?.town + ', ' : '' }}
                  {{
                    selectedData?.region?.isocodeShort
                      ? selectedData?.region?.isocodeShort + ' '
                      : ''
                  }}
                  {{ selectedData?.postalCode }}</span
                >
              </section>
              <section class="custome-modal">
                <ng-template #content let-modal>
                  <section class="modal-header cart-Modal-Header">
                    <button
                      type="button"
                      class="close"
                      aria-label="Close"
                      (click)="onCancel()"
                      (click)="modal.dismiss('Cross click')">
                      <img alt="" src="../../assets/icons/close.png" />
                    </button>
                    <h4 class="modal-title" id="modal-basic-title">
                      {{ 'account.select' | cxTranslate }}
                    </h4>
                  </section>
                  <section class="modal-body">
                    <section class="input-group loc-SearchBar">
                      <span class="input-group-btn">
                        <button class="btn" type="button">
                          <span class="loc-Search-Icon"> </span>
                        </button>
                        <input
                          type="text"
                          #clientName
                          (keyup)="searchClientName(clientName.value)"
                          class="form-control searchboxnew"
                          placeholder="{{
                            'account.filterByLocation' | cxTranslate
                          }}	" />
                      </span>
                    </section>
                    <hr
                      [ngClass]="{
                        displayNone: searchedClientList?.length === 0,
                      }" />
                    <section>
                      <section
                        [ngClass]="{
                          displayNone: searchedClientList?.length === 0,
                        }"
                        class="custom-control custom-radio radio_grp label-location w-100 m-0">
                        <table
                          *ngFor="let data of searchedClientList; let i = index"
                          aria-describedby="locTable"
                          class="w-100">
                          <tr class="sample-header">
                            <th scope="col"></th>
                            <th scope="col"></th>
                          </tr>
                          <tr
                            class="line-location"
                            [ngClass]="{
                              'label-location':
                                i !== searchedClientList.length - 1,
                            }">
                            <input
                              type="radio"
                              (change)="onOptionsSelected(data)"
                              [id]="data.id"
                              [checked]="selectedData.id === data.id"
                              name="customRadio"
                              class="custom-control-input" />

                            <label
                              class="custom-control-label secloct w-100"
                              [for]="data.id">
                              {{ data?.companyName }}
                              {{ '(' + data?.unitID + ')' }}
                            </label>
                            <p class="labelpp">
                              {{ data?.line1 ? data?.line1 + ', ' : '' }}
                              {{ data?.line2 ? data?.line2 + ', ' : '' }}
                              {{ data?.town ? data?.town + ', ' : '' }}
                              {{
                                data?.region?.isocodeShort
                                  ? data?.region?.isocodeShort + ' '
                                  : ''
                              }}
                              {{ data?.postalCode }}
                            </p>
                          </tr>
                        </table>
                      </section>
                    </section>
                  </section>
                  <section class="modal-footer">
                    <button
                      type="button"
                      class="btn location-done"
                      (click)="onSubmit()"
                      (click)="modal.close('Save click')">
                      {{ 'account.done' | cxTranslate }}
                    </button>
                  </section>
                </ng-template>
              </section>
            </section>
          </section>
        </section>
      </section>
      <section
        class="row mx-0 py-4"
        [ngClass]="{
          'margin-top-cart-row': i !== 0,
          'u-border-top-grey': i > 0,
        }"
        *ngFor="let product of fluProductsList; let i = index"
        id="{{ product.code }}">
        <!-- ====================Image======================================== -->
        <section class="col-2">
          <a (click)="productDetails(product)">
            <cx-media
              *ngIf="product.images"
              [container]="product.images"
              format="thumbnail">
            </cx-media>
            <img *ngIf="!product.images" [src]="fallbackImage" alt="defImg" />
          </a>

          <section class="container">
            <section class="row">
              <section
                class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 delete-popover-container delete-Div c-link">
                <i class="fas fa-trash-alt pointer"></i>
                <span
                  [ngbPopover]="popContentDelete"
                  [popoverTitle]="popTitleDelete"
                  triggers="manual"
                  #p2="ngbPopover"
                  placement="top"
                  class="trash cart-edit-delete"
                  (click)="toggle(p2)"
                  >{{ 'orderConfirmation.delete' | cxTranslate }}</span
                >

                <ng-template #popTitleDelete>
                  {{ 'addToCartItems.deleteTitle' | cxTranslate }}</ng-template
                >
                <ng-template #popContentDelete>
                  <div class="d-flex gap-1">
                    <button
                      type="reset"
                      class="popover-close c-button c-button--secondary popover-cancel-button"
                      data-di-id="di-id-d01008be-fb6e135c"
                      (click)="toggle(p2)">
                      {{ 'addToCartItems.cancel' | cxTranslate }}
                    </button>
                    <button
                      class="c-button c-button--primary popover-cancel-button"
                      type="submit"
                      data-di-id="di-id-3064f17d-e97cc628"
                      (click)="
                        deleteIndividualCartItem(product, p2, sectionIndex)
                      ">
                      {{ 'addToCartItems.delete' | cxTranslate }}
                    </button>
                  </div>
                </ng-template>
              </section>
            </section>
          </section>
        </section>
        <!-- ====================Product Detia======================================== -->
        <section class="col-lg-5 c-prod-details">
          <a (click)="productDetails(product)">
            <h2
              class="c-heading c-heading-h4 mb-4"
              [innerHTML]="product.name"></h2>
          </a>
          <p
            class="text-fixed-medium color-grey"
            [innerHTML]="product.description"></p>
          <p class="text-fixed-legal-copy color-grey-dark mb-1">
            <span class="font-bold">
              {{ 'selectVaccines.product_number' | cxTranslate }}</span
            >{{ product.sapEan }}
          </p>
        </section>
        <!-- ============================Price=========================================== -->
        <section class="col-xs-6 col-md-6 col-lg-3 price-list">
          <section class="row" *ngIf="isPharmacyUser$ | async">
            <section class="col-md-12">
              <span class="c-heading c-heading-h3">{{
                product?.price?.formattedValue
              }}</span>
            </section>
          </section>
        </section>
        <!-- ==============================units========================================== -->
        <section class="col-2 p0">
          <section
            class="prodUnits"
            *ngIf="
              product.available === true && product.discontinued === false;
              else NotAccept
            ">
            <div class="mb-2 text-center font-weight-bold color-grey-dark">
              {{ 'selectVaccines.units' | cxTranslate }}
            </div>
            <section
              class="unit-area d-flex flex-nowrap align-items-center justify-content-center">
              <span class="disabled" id="{{ 'minusIcon' + product?.code }}">
                <button
                  id="{{ 'unitMinus' + product?.code }}"
                  class="c-count-change-btn"
                  (click)="
                    performQuantityComputation(
                      2,
                      product?.code,
                      product?.quantityPerUnit
                    )
                  ">
                  <i class="fa fa-minus"></i>
                </button>
                <button
                  id="{{ 'unitMinusDisable' + product?.code }}"
                  class="disable-action c-count-change-btn">
                  <i class="fa fa-minus"></i>
                </button>
              </span>
              <input
                type="number"
                class="prod-quantity text-center"
                value="{{
                  product?.totalQuantity ? product?.totalQuantity : '0'
                }}"
                onkeypress="return /[0-9a-zA-Z]/i.test(event.key)"
                (keyup)="
                  performQuantityComputation(
                    null,
                    product?.code,
                    product?.quantityPerUnit
                  )
                "
                id="{{ 'prodQuantity' + product?.code }}"
                min="0"
                max="99999" />
              <span id="{{ 'plusIcon' + product?.code }}">
                <button
                  (click)="
                    performQuantityComputation(
                      1,
                      product?.code,
                      product?.quantityPerUnit
                    )
                  "
                  id="{{ 'unitPlus' + product?.code }}"
                  class="c-count-change-btn">
                  <i class="fa fa-plus"></i>
                </button>
                <button
                  id="{{ 'unitPlusDisable' + product?.code }}"
                  class="disable-action c-count-change-btn">
                  <i class="fa fa-plus"></i>
                </button>
              </span>
            </section>

            <section
              class="mt-2 text-center"
              id="{{ 'noOfDoses' + product?.code }}">
              {{ product?.totalDoses ? product?.totalDoses : '' }}
              {{
                product?.totalDoses
                  ? ('selectVaccines.doses' | cxTranslate)
                  : ''
              }}
            </section>
          </section>

          <ng-template #NotAccept>
            <section class="units-Non-Accepting">
              <span
                *ngIf="!product.available && product.discontinued === false"
                class="Not-Available">
                {{
                  product?.availabilityText
                    ? product?.availabilityText
                    : ('selectVaccines.product_unavailable' | cxTranslate)
                }}
              </span>
              <span
                class=""
                *ngIf="product.discontinued === true"
                class="Not-Available">
                {{ 'selectVaccines.product_discontinued' | cxTranslate }}</span
              >
            </section>
          </ng-template>
        </section>
      </section>
    </section>
    <!-- ==================NO DATA============================================== -->
    <section
      class="col-12 col-sm-12 col-md-12 col-lg-8 col-xl-8 border-Right-empty-Cart"
      *ngIf="showEmptyCart">
      <section class="container emptyCart-container">
        <section class="row">
          <h3 class="orderConfirmationHeader">
            {{ 'orderConfirmation.emptyCart' | cxTranslate }}
          </h3>
        </section>
        <section class="row order-products-row">
          <span class="c-link" (click)="navigateToProducts()">{{
            'orderConfirmation.orderProds' | cxTranslate
          }}</span>
        </section>
        <section class="row reserve-link-row">
          <span class="c-link" (click)="backToDashBoard()">{{
            'orderConfirmation.reserveVaccines' | cxTranslate
          }}</span>
        </section>
      </section>
    </section>
    <!-- =====================Right Section========================= -->
    <section class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 no-print mt-5">
      <!-- =====================estimation======================= -->
      <section
        class="align-items-center col-md-12 col-lg-12 col-xl-12 estHeader-ipad cart-Proceed-Section c-heading c-heading-h3 text-center d-flex gap-1"
        *ngIf="isPharmacyUser$ | async">
        <span class="col-8">
          {{ 'orderConfirmation.orderSubTotal' | cxTranslate }}
        </span>
        <span>{{
          cartNeedToBeUpdated ? '-' : estimatedSubtotal?.formattedValue
        }}</span>
      </section>
      <div class="px-3">
        <button
          class="c-button c-button--primary w-100"
          (click)="navigateToCheckout()"
          *ngIf="!cartNeedToBeUpdated"
          [ngClass]="{ 'block-Click': disableButton }"
          [disabled]="
            !fluProductsList.length ||
            !minDosesThresholdRespected ||
            (!(isDirectUser$ | async) && !(wholeSalerPharmacy$ | async))
          ">
          <i class="fa fa-spinner fa-spin" *ngIf="disableButton"></i>
          {{ 'selectVaccines.proceedToCheckout' | cxTranslate }}
        </button>
        <button
          class="c-button c-button--secondary w-100"
          *ngIf="cartNeedToBeUpdated"
          (click)="navigateToCheckout()"
          [ngClass]="{ 'block-Click': disableButton }"
          [disabled]="
            fluProductsList.length == 0 || !minDosesThresholdRespected
          ">
          <i class="fa fa-spinner fa-spin" *ngIf="disableButton"></i>
          {{ 'selectVaccines.updateOrder' | cxTranslate }}
        </button>
        <p class="color-error mt-4" *ngIf="!minDosesThresholdRespected">
          {{
            'checkout.minDosesThreshold.warning'
              | cxTranslate: { '0': minDosesThreshold }
          }}
        </p>
      </div>
      <div
        class="mt-5 u-border-top-grey col-12"
        *ngIf="!(isDirectUser$ | async)">
        <app-wholesaler-pharmacy></app-wholesaler-pharmacy>
      </div>
    </section>
  </section>
</section>
